const SMALL = new Set(["a", "an", "and", "as", "at", "but", "by", "for", "in", "of", "on", "or", "the", "to", "vs", "with"]);

/**
 * A package's name in one house style (1NOW-11174). Operators type them freely ("BASIC PROTECTION", "full cover",
 * "Rental cover"), and side by side in a list they read as three styles: every word starts with a capital, but the
 * small joining words ("and", "of", "the"...) do not. Acronyms of up to three capitals (LDW, SLI) and words that
 * are cased on purpose ("PremiumPlus") are left as typed.
 */
export const titleCase = (name: string): string =>
  name
    .trim()
    .split(/\s+/)
    .map((word, i) => {
      const lower = word.toLowerCase();
      if (i > 0 && SMALL.has(lower)) return lower;
      if (/^[A-Z0-9&/+-]{1,3}$/.test(word) && /[A-Z]/.test(word)) return word;
      if (/[a-z]/.test(word) && /[A-Z]/.test(word.slice(1))) return word;
      return lower.replace(/(^|[-/(])([a-z])/g, (_m, edge: string, c: string) => edge + c.toUpperCase());
    })
    .join(" ");
